module.exports = __webpack_public_path__ + "img/toon_5.8d35049f.png";